import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import React from "react";
import styles from "./InputBox.module.scss";
import "../../../styles/focus-ring.scss";

export interface InputBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md";
  asChild?: boolean;
  error?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  forwardToInput?: boolean;
  fullWidth?: boolean;
}

const InputBox = (props: InputBoxProps) => {
  const { size = "md", asChild, error, disabled, className, children, forwardToInput, fullWidth = false, ...otherProps } = props;
  const Comp = asChild ? Slot : "div";
  return (
    <Comp
      data-size={size}
      data-forward={forwardToInput}
      data-full-width={fullWidth ? "true" : "false"}
      className={clsx(styles.inputBox, className)}
      data-error={error ? "true" : "false"}
      data-disabled={disabled ? "true" : "false"}
      data-focus-ring="within"
      {...otherProps}
    >
      {children}
    </Comp>
  );
};

export default InputBox;
